<!-- src/components/CookieConsent/CookiePreferencesModal.vue -->
<template>
  <div>
    <el-dialog
      :visible="visible"
      :title="$t('cookie.cookieSet')"
      width="80%"
      :before-close="handleClose"
      class="cookie-preferences-dialog"
      :top="top"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-header">
        <span>{{ $t('cookie.cookieSet') }}</span>
        <!-- <div class="header-right">
          <span class="language-selector">中文</span>
          <el-avatar size="small" icon="el-icon-user-solid">Ha</el-avatar>
        </div> -->
      </div>

      <el-row :gutter="20" class="dialog-body">
        <!-- 左侧类别列表 -->
        <el-col :xs="24" :sm="24" :md="5" :lg="5" class="categories-sidebar">
          <el-menu
            :default-active="activeCategory"
            @select="handleCategorySelect"
            class="category-menu"
          >
            <el-menu-item 
              v-for="(category, id) in cookieCategories" 
              :key="id"
              :index="id"
            >
              {{ category.name }}
            </el-menu-item>
          </el-menu>
        </el-col>

        <!-- 右侧详情区域 -->
        <el-col :xs="24" :sm="24" :md="19" :lg="19" class="category-detail" v-if="activeCategory">
          <div class="detail-header">
            <h4>{{ currentCategory.name }}</h4>
            <el-switch
              v-if="cookiesInCategory.length > 0"
              v-model="localConsent[activeCategory]"
              :key="'switch-' + activeCategory"
              :disabled="currentCategory.required"
              @change="val => toggleCategory(activeCategory, val)"
            />
          </div>
          
          <el-alert
            :title="currentCategory.description"
            type="info"
            :closable="false"
            show-icon
            class="category-description"
          />

          <p class="policy-link">
            {{ $t('cookie.cookieSetExplain') }}
            <el-link class="link-text" type="primary" target="_blank" @click="openCookiePolicy('cookie.cookiePolicy')">{{ $t('cookie.cookiePolicy') }}</el-link>
          </p>

          <!-- Cookie表格 -->
          <el-table
            v-if="cookiesInCategory.length > 0"
            :data="cookiesInCategory"
            border
            size="small"
            class="cookies-table"
            :max-height="400"
            :key="'switch-' + activeCategory"
          >
            <el-table-column prop="name" :label="$t('cookie.cookieCategory')" width="120" />
            <el-table-column prop="cookieName" :label="$t('cookie.cookieName')" width="120" />
            <el-table-column prop="description" :label="$t('cookie.cookieDescription')" min-width="200" />
            <el-table-column prop="duration" :label="$t('cookie.cookieDuration')" width="100" />
            <el-table-column :label="$t('cookie.cookieSwitch')" width="100" align="center">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.required" class="disabled-text">不可关闭</span> -->
                <el-switch
                  v-if="scope.row"
                  v-model="localConsent[activeCategory]"
                  disabled
                  size="small"
                />
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleAcceptNecessary">{{ $t('cookie.acceptNecessary') }}</el-button>
        <el-button type="primary" @click="handleSavePreferences">{{ $t('cookie.savePreferences') }}</el-button>
        <el-button type="primary" @click="handleAcceptAll">{{ $t('cookie.acceptAll') }}</el-button>
      </span>
    </el-dialog>
    <IPolicyDialog ref="policyDialog" :visible.sync="policy.visibleSync" :content="policy.content" :title="policy.title" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { commonOpenCookiePolicy, openPolicy } from '@/utils/common.js'
import { openAgreementPage, policyConst } from '@/views/policyConfiguration/config.js'
import IPolicyDialog from '@/components/IPolicyDialog'
import { getPolicyDetailByLanAndType } from '@/api/policy'

export default {
  name: 'CookiePreferencesModal',
  components: {
    IPolicyDialog
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      activeCategory: 'necessary',
      localConsent: {},
      top: '50px', // 固定顶部距离
      policy: {
        visibleSync: false,
        content: '',
        title: ''
      }
    };
  },

  computed: {
    ...mapState('cookie', ['cookieCategories', 'consent']),
    ...mapGetters('cookie', ['getCookiesByCategory']),

    currentCategory() {
      return this.cookieCategories[this.activeCategory] || {};
    },

    cookiesInCategory() {
      return this.getCookiesByCategory(this.activeCategory) || [];
    }
  },

  watch: {
    consent: {
      handler(newVal) {
        this.localConsent = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions('cookie', [
      'acceptAll',
      'acceptNecessaryOnly',
      'savePreferences',
      'closePreferences',
      'closeAllCookieModals',
      'updateCategoryPreference'
    ]),

    openCookiePolicy(policyTitle) {
      const privacyType = policyConst.COOKIE_POLICY
      getPolicyDetailByLanAndType({
          lan: localStorage.getItem('Accept-Language') || 'en-US',
          privacyType
      }).then(res => {
          if(res?.code == 200 && res?.data?.content) {
              this.policy.content = res?.data?.content || ''
              this.policy.title = policyTitle
              this.policy.visibleSync = true
          } else {
              openAgreementPage(privacyType)
          }
      }).catch(error => {
          openAgreementPage(privacyType)
      })
    },

    handleCategorySelect(index) {
      this.activeCategory = index;
    },

    handleClose() {
      // 关闭弹窗时，重置本地状态为全局状态
      this.localConsent = { ...this.consent };
      this.closePreferences();
    },

    toggleCategory(category, value) {
      // this.updateCategoryPreference({ category, value });
      // 只更新本地状态，不更新全局状态，直到用户点击保存
      this.$set(this.localConsent, category, value);
    },

    handleAcceptNecessary() {
      this.acceptNecessaryOnly();
      this.closePreferences();
    },

    handleSavePreferences() {
      // this.savePreferences();
      // 将本地状态同步到全局状态
      this.$store.commit('cookie/SET_CONSENT', { ...this.localConsent });
      this.closeAllCookieModals();
    },

    handleAcceptAll() {
      this.acceptAll();
    }
  }
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.language-selector {
  font-size: 14px;
  color: #909399;
  cursor: pointer;
}

.language-selector:hover {
  color: #409EFF;
}

.dialog-body {
  min-height: 400px;
  max-height: 600px; /* 固定最大高度 */
  overflow-y: auto;
}

.categories-sidebar {
  border-right: 1px solid #EBEEF5;
}

.category-menu {
  border-right: none;
}

.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.detail-header h4 {
  margin: 0;
  font-size: 16px;
  color: #303133;
}

.category-description {
  margin-bottom: 16px;
}

.policy-link {
  font-size: 14px;
  color: #606266;
  margin: 16px 0;
  display: flex;
}

.link-text {
  margin-left: 4px;
}

.cookies-table {
  margin-top: 16px;
}

.disabled-text {
  color: #C0C4CC;
  font-size: 12px;
}

/* ElementUI 样式覆盖 */
::v-deep .el-dialog__body {
  padding: 20px;
  max-height: 550px; /* 固定最大高度 */
  overflow-y: auto;
}

::v-deep .el-menu-item {
  height: 50px;
  line-height: 50px;
}

::v-deep .el-menu-item.is-active {
  background-color: #ecf5ff;
}

::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
}

/* 移动端适配 */
@media (max-width: 768px) {
  ::v-deep .el-dialog {
    width: 95%;
    margin-top: 20px !important; /* 固定顶部距离 */
  }

  .dialog-body {
    max-height: 500px; /* 移动端稍小一些 */
  }

  .categories-sidebar {
    border-right: none;
    border-bottom: 1px solid #EBEEF5;
    margin-bottom: 20px;
  }

  .category-menu {
    display: flex;
    overflow-x: auto;
  }

  ::v-deep .el-menu-item {
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
  }

  .dialog-footer {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .dialog-footer .el-button {
    margin-left: 0 !important;
    width: 100%;
  }

  ::v-deep .el-dialog__body {
    max-height: 400px; /* 移动端更小一些 */
  }
}
</style>
